import React from 'react'
import { A11y, A11yIndexProps } from 'react-native-a11y-order'

type A11yOrderProps = React.ComponentProps<typeof A11y.Order>

//For web, these are no-ops
export const A11yOrder: React.FC<A11yOrderProps> = (props) => {
  return <React.Fragment>{props.children}</React.Fragment>
}

export const A11yIndex: React.FC<A11yIndexProps> = (props) => {
  return <React.Fragment>{props.children}</React.Fragment>
}
